/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Paper, Typography, Divider, IconButton, Grid, CircularProgress, Collapse, Button } from '@material-ui/core'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepButton from '@material-ui/core/StepButton';
import StepLabel from '@material-ui/core/StepLabel';

import CreateIU from './AddDataDevice/CreateIU'
import SetAccessDetails from './AddDataDevice/SetAccessDetails'
import AdaptorInputs from './AddDataDevice/AdaptorInputs'
import FieldsInScope from './AddDataDevice/FieldsInScope'
import SetTemporalField from './AddDataDevice/SetTemporalField'
import ConfigureWV from './AddDataDevice/ConfigureWV';
import SetDataMarkers from './AddDataDevice/SetDataMarkers'
import ConfigureDisplay from './AddDataDevice/ConfigureDisplay'

import { TrendingUpRounded, Warning } from '@material-ui/icons'

import Clear from '@material-ui/icons/Clear'

import Action from '../../fluid/Actions/ActionFactory'

const styles = theme => ({

})

const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

function getSteps() {
    return ['Create Information Unit', 'Set Access Details', 'Adaptor Inputs', 'Fields In Scope', 'Set Temporal Field', 'Set Data Markers', 'Configure World View', 'Configure Display'];
}

class AddDataDevice extends Component {
    state = {
        activeStep : 0,
        steps : getSteps(),
        iu_name :  null,
        content_height : null,
        ws_name : null,
        closing : false,
        show_close_alert : false,
        anchor_close_alert : null
    }

    componentWillMount () {
        console.log('IU Name: ', this.props.iu_name)
        if (this.props.iu_name !== null) {
            this.setState({...this.state, iu_name : this.props.iu_name, activeStep : 1})
        }
    }

    head = React.createRef()
    dialog = React.createRef()

    componentDidMount () {
        const headHeight = this.head.current.clientHeight
        const dialogHeight = this.dialog.current.clientHeight
        const contentHeight = dialogHeight - headHeight

        console.log('Dialog Content Height : ', contentHeight)
        this.setState({...this.state, content_height : contentHeight})
    }
    
    handleStep = (step) => {
        this.setState({...this.state, activeStep : step})
    }

    handleNext = (obj) => {
        
        this.setState({...this.state, 
            activeStep : this.state.activeStep === this.state.steps.length - 1 ? -1 :this.state.activeStep + 1,
            ...obj
        }, () => {
            if (this.state.activeStep === - 1) {
                this.closingPopUp()
            }
        })
    };
    
    handleBack = () => {
        this.setState({...this.state, activeStep : this.state.activeStep === 0 ? this.state.activeStep : this.state.activeStep - 1})
    };

    renderStep = (step) => {
        switch (step) {
            case 0:
                return (
                    <CreateIU ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )
            
            case 1:
                return (
                    <SetAccessDetails ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )

            case 2: 
                return (
                    <AdaptorInputs ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )

            case 3: 
                return (
                    <FieldsInScope ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )
            
            case 4: 
                return (
                    <SetTemporalField ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )

            case 5: 
                return (
                    <SetDataMarkers ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} ws_name = {this.state.ws_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>
                )

            case 6: 
                return <ConfigureWV wv_ic_name = {this.props.ic_name} ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height} submit = {true}/>
            
            case 7:
                return <ConfigureDisplay ic_name = {this.props.ic_name} iu_name = {this.state.iu_name} handleNext = {(obj) => this.handleNext(obj)} maxHeight = {this.state.content_height}/>

            default:
                return null
        }
    }

    closingPopUp = (event) => {
        if (this.state.iu_name === null) {
            this.setState({...this.state, activeStep : 0, show_close_alert : false}, () => this.props.close())
        } else {
            Action('http_request', {
                url : "/sainapse/information_channel/" + this.props.ic_name + "/information_unit/" + this.state.iu_name,
                method : "get",
                data : {}
            }).then(res => {
                console.log("IU Result : ", res)
                if (!res.data.result.setup_complete) {
                    this.setState({...this.state, show_close_alert : true }, () => console.log("IU CLosing State : ", this.state))
                } else {
                    this.setState({...this.state, activeStep : 0, show_close_alert : false}, () => this.props.close())
                }
            })
        }
    }

    render() {
        const { classes } = this.props
        return (
            <Paper ref = {this.dialog} style = {{width : '85vw', height : '85vh'}}>
                <div ref = {this.head} style = {{width : '100%'}}>
                    <div style = {{display : 'flex', flexDirection : 'row', padding : '8px'}}>
                        <Typography style = {{ flexGrow : 1}} variant = 'h6'>Adding Information Unit <em>{this.state.iu_name}</em></Typography>
                        <IconButton size = 'small' color = 'secondary' onClick = {(event) => this.closingPopUp(event)}>
                            <Clear/>
                        </IconButton>
                    </div> 
                    <Divider/>
                    <ThemeProvider theme = {blue_theme}>
                        <Stepper nonLinear style = {{width : '100%'}} activeStep={this.state.activeStep} alternativeLabel>
                            {this.state.steps.map((label, i) => (
                                <Step key={label}>
                                    <StepButton 
                                        onClick = {() => this.handleStep(i)}
                                    >
                                        {label}
                                    </StepButton>
                                </Step>
                            ))}
                        </Stepper>
                    </ThemeProvider>
                    <Divider/>
                </div>
                <Collapse in = {this.state.show_close_alert}>
                    <Paper style = {{width  : "100%", height : this.state.content_height, display : 'flex', flexDirection : 'column', alignItems : 'center', justifyContent : 'center'}}>
                        <Warning style = {{color : '#cc3300', fontSize : '40px', margin : '10px'}}/>
                        <div style = {{width : '60%', textAlign : 'center'}}>
                            <Typography color = 'textSecondary'>You are exiting the IU Registration process without completing the setup. You will not be able to use this IU unless the setup is complete. Do you want to continue exiting the setup?</Typography>
                        </div>
                        <div>
                            <ThemeProvider theme = {blue_theme}>
                                <Button
                                    style = {{margin : '10px'}}
                                    variant = 'outlined'
                                    color = 'secondary'
                                    onClick = {() => this.setState({...this.state, activeStep : 0, show_close_alert : false}, () => this.props.close())}
                                >Exit Setup</Button>
                                <Button
                                    style = {{margin : '10px'}}
                                    variant = 'contained'
                                    color = 'primary'
                                    onClick = {() => this.setState({...this.state, show_close_alert : false})}
                                >Cancel</Button>
                            </ThemeProvider>
                        </div>
                    </Paper>
                </Collapse>
                <Collapse in = {!this.state.show_close_alert}>
                    <Grid style = {{height : this.state.content_height}} xs = {12} container>
                        {this.renderStep(this.state.activeStep)}
                    </Grid>
                </Collapse>
            </Paper>
        );
    }
}

export default withStyles(styles)(AddDataDevice);